import React from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function Property(props) {
    const Choice = ComponentRegistry.get("Choice");

    return (
      <div className="form-group clearfix">
        <Choice {...props} />
      </div>
    );
}



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Atoms/Property.jsx